<style src="./InProgressEvent.scss" lang="scss"></style>
<template>
  <section class="in-progress-event">
    <div class="participation">
      <div class="participated">
        <span class="title">EVENTOS EM FASE DE LANCE</span>
        <span class="value">{{ countTotal }}</span>
      </div>
      <div class="participated">
        <span class="title">EVENTOS AGUARDANDO RETORNO</span>
        <span class="value waiting">{{ waitingMode }}</span>
      </div>
    </div>
    <div class="total">
      <span><strong>{{ countInProgress }}</strong> EVENTOS EM FASE DE LANCES</span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'InProgressEvent',
  props: {
    countInProgress: {
      default: null
    },
    waitingMode: {
      default: null
    }
  },
  computed: {
    countTotal () {
      return Number(this.countInProgress) - Number(this.waitingMode)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/dashboard/components/in-progress-events/InProgressEvent.vue